// Human delivery summary from a deliveryPlan. Handles the NEW items[] format
// (kind DRUM/COIL, lengthPerUnit, qtyPlanned) AND legacy drums[]/coils[]. The old
// summary builder only counted coils, so drums (TAMBURI) were dropped from the rezumat.
const num = v => Number(v) || 0;

export function buildDeliverySummary(plan) {
  if (!plan) return '';
  const items = Array.isArray(plan.items) ? plan.items : [];
  const drums = [];
  const coils = [];

  if (items.length) {
    for (const it of items) {
      const qty = num(it.qtyPlanned ?? it.quantity);
      const len = num(
        it.lengthPerUnit ?? it.length ?? it.lengthPerDrum ?? it.lengthPerCoil
      );
      if (!qty || !len) continue;
      if (String(it.kind || '').toUpperCase() === 'DRUM') {
        drums.push({
          drumMaterial: it.drumMaterial || '',
          drumDiameter: it.drumDiameter || '',
          len,
          qty
        });
      } else {
        coils.push({ len, qty });
      }
    }
  } else {
    for (const d of plan.drums || []) {
      if (num(d.quantity) && num(d.lengthPerDrum))
        drums.push({
          drumMaterial: d.drumMaterial || '',
          drumDiameter: d.drumDiameter || '',
          len: num(d.lengthPerDrum),
          qty: num(d.quantity)
        });
    }
    for (const c of plan.coils || []) {
      if (num(c.quantity) && num(c.lengthPerCoil))
        coils.push({ len: num(c.lengthPerCoil), qty: num(c.quantity) });
    }
  }

  // group drums by material + diameter + length
  const byDrum = new Map();
  for (const d of drums) {
    const key = `${d.drumMaterial}|${d.drumDiameter}|${d.len}`;
    const prev = byDrum.get(key) || { ...d, qty: 0 };
    prev.qty += d.qty;
    byDrum.set(key, prev);
  }
  const drumParts = [...byDrum.values()].map(x => {
    const specs = [x.drumMaterial, x.drumDiameter ? `Ø${x.drumDiameter}` : '']
      .filter(Boolean)
      .join(' ');
    return `${specs || 'Drum'}: ${x.qty}×${x.len}m`;
  });

  // group coils by length
  const byCoil = new Map();
  for (const c of coils) {
    const prev = byCoil.get(String(c.len)) || { len: c.len, qty: 0 };
    prev.qty += c.qty;
    byCoil.set(String(c.len), prev);
  }
  const coilParts = [...byCoil.values()].map(c => `${c.qty}×${c.len}m`);

  const parts = [];
  if (drumParts.length) parts.push(`Tamburi: ${drumParts.join(', ')}`);
  if (coilParts.length) parts.push(`Coils: ${coilParts.join(', ')}`);
  return parts.join('; ');
}
